import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Eye2Icon from '../../Icons/Eye2';
import PremiumFolderIcon from '../../Icons/PremiumFolder';
import s from './FolderBadge.scss';
var FolderBadge = function (_a) {
    var mode = _a.mode, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['root'], s[mode], className) },
        mode === 'watchers' ? (React.createElement(Eye2Icon, { className: s['icon'] })) : (React.createElement(PremiumFolderIcon, { className: s['icon'] })),
        React.createElement("span", null, t("folderCard.badge." + mode))));
};
FolderBadge.displayName = 'FolderBadge';
export default FolderBadge;
//# sourceMappingURL=FolderBadge.js.map